import { getType } from 'typesafe-actions'
import { ActionTypes } from '../actions/types'
import { closeErrorMessage, setTraceId, uploadFailed, uploadStart } from '../actions/upload'

export interface UploadState {
  readonly traceId?: string
  readonly uploading: boolean
  readonly error: boolean
}

const initialState: UploadState = {
  uploading: false,
  error: false,
}

export default (state: UploadState = initialState, action: ActionTypes) => {
  switch (action.type) {
    case getType(setTraceId):
      return {
        ...state,
        traceId: action.payload.traceId,
      }
    case getType(uploadStart):
      return {
        ...state,
        uploading: true,
      }
    case getType(uploadFailed):
      return {
        ...state,
        uploading: false,
        error: true,
      }
    case getType(closeErrorMessage):
      return {
        ...state,
        uploading: false,
        error: false,
      }
    default:
      return state
  }
}
